var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(-254 -695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    transform: "translate(295 736) rotate(180)",
    fill: "none",
    stroke: "#2979ff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 19.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    "data-name": "Vector 18",
    d: "M4.5,0,0-4.5,4.5-9",
    transform: "translate(279 711) rotate(180)",
    fill: "none",
    stroke: "#2979ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    "data-name": "Vector 19",
    d: "M0,0H8.5",
    transform: "translate(278.5 715.5) rotate(180)",
    fill: "none",
    stroke: "#2979ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.d5891c408ee7a34f679b382a611bf8e4.svg";
export { ForwardRef as ReactComponent };